import { Button, Flex, useColorModeValue } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { sections } from 'views/client/education/variable/sections';

export default function EducationLinks({ current, isClient }) {
	const textColor = useColorModeValue('brand.500', 'brand.500');
	const navigate = useNavigate();

	return (
		<Flex
			mb={10}
			width={'100%'}
			justifyContent={isClient ? 'flex-end' : 'space-around'}
			gap={'10px'}
			flexDirection={{ base: 'column', md: 'row' }}
		>
			{sections
				.filter((section) => section.identifier !== current)
				.map((section, idx) => (
					<Button
						variant={'brand'}
						onClick={() =>
							navigate(
								isClient ? section.link : section.link.replace('/client', '')
							)
						}
						key={idx}
						whiteSpace={'wrap'}
						width={{ base: '100%', md: 'fit-content' }}
					>
						{section.title}
					</Button>
				))}
		</Flex>
	);
}
